module.exports = __webpack_public_path__ + "static/dating-design-09-71927e1b834cb3337840c931fd42327a.jpg";